import { Template } from "../../models";
import webCoffee from "../../assets/images/storeImages/Web_Coffee.png";
import webDeliciousChicken from "../../assets/images/storeImages/Web_DELICIOUS_chicken.png";
import webGymCoaching from "../../assets/images/storeImages/Web_Gym_COACHING.png";
import webHotelHotux from "../../assets/images/storeImages/Web_HOTEL_HOTUX.png";
import webModernInteriorDesignStudio from "../../assets/images/storeImages/Web_Modern_Interior_Design_Studio.png";
import webPetCareServiceCompany from "../../assets/images/storeImages/Web_Pet_Care_Service_Company.png";
import webPheLieu from "../../assets/images/storeImages/Web_Phe_Lieu.png";
import webShopE from "../../assets/images/storeImages/Web_ShopE.png";
import webSnackLoud from "../../assets/images/storeImages/Web_SNACK_LOUD.png";

export const templates: Template[] = [
  {
    id: 1,
    name: "Coffee House",
    title: "Coffee House - Website thương hiệu cà phê & bán hàng trực tuyến",
    img: webCoffee,
    category: "coffee-house",
    solutionType: "web-commerce",
    industry: "F&B / Cà phê",
    highlights: [
      "Giao diện tinh gọn, dễ dẫn dắt khách hàng tới menu và đặt hàng",
      "Phù hợp cho thương hiệu cần xây dựng nhận diện và tăng chuyển đổi online",
    ],
  },
  {
    id: 2,
    name: "Delicious Chicken",
    title: "Delicious Chicken - Website bán hàng cho chuỗi đồ ăn nhanh",
    img: webDeliciousChicken,
    category: "fast-food",
    solutionType: "web-commerce",
    industry: "F&B / Bán hàng",
    highlights: [
      "Bố cục rõ món, combo và ưu đãi để tăng giá trị đơn hàng",
      "Thích hợp triển khai cho mô hình bán mang đi, giao hàng và chiến dịch khuyến mãi",
    ],
  },
  {
    id: 3,
    name: "Gym Coaching",
    title: "Gym Coaching - Landing page dịch vụ huấn luyện & chuyển đổi lead",
    img: webGymCoaching,
    category: "fitness",
    solutionType: "landing",
    industry: "Fitness / Dịch vụ",
    highlights: [
      "Tập trung CTA đăng ký tư vấn và hành trình chuyển đổi khách hàng mới",
      "Phù hợp chạy quảng cáo lead form cho dịch vụ huấn luyện cá nhân",
    ],
  },
  {
    id: 4,
    name: "Hotel Hotux",
    title: "Hotel Hotux - Website khách sạn & tối ưu đặt phòng trực tiếp",
    img: webHotelHotux,
    category: "hotel",
    solutionType: "web-commerce",
    industry: "Khách sạn / Du lịch",
    highlights: [
      "Tối ưu trải nghiệm đặt phòng và giới thiệu hạng phòng rõ ràng",
      "Phù hợp cho khách sạn muốn tăng tỷ lệ booking trực tiếp từ website",
    ],
  },
  {
    id: 5,
    name: "Interior Design Studio",
    title: "Interior Design Studio - Website doanh nghiệp cho studio nội thất",
    img: webModernInteriorDesignStudio,
    category: "interior",
    solutionType: "web-commerce",
    industry: "Nội thất / Doanh nghiệp",
    highlights: [
      "Tôn trọng hình ảnh dự án và hồ sơ năng lực thương hiệu",
      "Phù hợp cho doanh nghiệp cần kết hợp portfolio và kênh tư vấn khách hàng",
    ],
  },
  {
    id: 6,
    name: "Pet Care Service",
    title: "Pet Care Service - Website dịch vụ chăm sóc thú cưng",
    img: webPetCareServiceCompany,
    category: "pet-care",
    solutionType: "landing",
    industry: "Dịch vụ / Pet Care",
    highlights: [
      "Dễ triển khai nội dung dịch vụ, bảng giá và form đăng ký nhanh",
      "Tối ưu cho mô hình cần tạo niềm tin và chốt lịch hẹn trực tuyến",
    ],
  },
  {
    id: 7,
    name: "Việt Lợi Phế Liệu",
    title: "Việt Lợi Phế Liệu - Website doanh nghiệp B2B & quản lý danh mục sản phẩm",
    img: webPheLieu,
    category: "industrial-b2b",
    solutionType: "dashboard",
    industry: "Công nghiệp / B2B",
    highlights: [
      "Phù hợp cho doanh nghiệp có danh mục sản phẩm phức tạp và quy trình báo giá",
      "Có thể nâng cấp thành nền tảng quản trị lead và dữ liệu khách hàng nội bộ",
    ],
  },
  {
    id: 8,
    name: "ShopE",
    title: "ShopE - Nền tảng thương mại điện tử cho bán lẻ đa ngành",
    img: webShopE,
    category: "retail",
    solutionType: "web-commerce",
    industry: "Bán lẻ / Ecommerce",
    highlights: [
      "Thiết kế rõ luồng mua hàng, danh mục và chi tiết sản phẩm",
      "Phù hợp cho doanh nghiệp cần triển khai nhanh kênh bán hàng trực tuyến",
    ],
  },
  {
    id: 9,
    name: "Snack Loud",
    title: "Snack Loud - Website thương hiệu thực phẩm & chiến dịch bán hàng",
    img: webSnackLoud,
    category: "snack-brand",
    solutionType: "landing",
    industry: "Thực phẩm / Marketing",
    highlights: [
      "Tối ưu truyền tải thương hiệu và sản phẩm theo hướng trẻ trung, năng động",
      "Dễ kết hợp với chiến dịch quảng cáo và các điểm chạm chuyển đổi trên landing page",
    ],
  },
];
